import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        textHeadingOne: 'Start building intelligent chatbots for free!',
        textParagraph: 'Install a chatbot to your Facebook page in less than 5 minutes without programming!',
        fullName: 'Full name',
        errorMessageFullName: 'Invalid name',
        email: 'Email address',
        errorMessageEmail: 'Invalid email',
        password: 'Password',
        errorMessagePassword: 'Invalid password',
        verifyPassword: 'Verify password',
        errorMessageVerifyPassword: 'Invalid password',
        formButtonText: 'Create account',
        disclaimer: 'By clicking “Create Account” I agree to Frankie’s <a class="textAnchor color-primary" href="/terms-of-use">Terms of Service </a>and <a class="textAnchor color-primary" href="/privacy-policy">Privacy Policy</a>.',
        errorMessage: 'Something went wrong, try again'
    },
    es: {
        textHeadingOne: 'Empieza a crear chatbots totalmente gratis.',
        textParagraph: 'Instala un chatbot a tu página de Facebook en menos de 5 minutos sin saber programar!',
        fullName: 'Nombre completo',
        errorMessageFullName: 'Nombre inválido',
        email: 'Correo',
        errorMessageEmail: 'Correo inválido',
        password: 'Contraseña',
        errorMessagePassword: 'Contraseña incorrecta',
        verifyPassword: 'Verifica tu contraseña',
        errorMessageVerifyPassword: 'Contraseña inválida',
        formButtonText: 'Crear una cuenta',
        disclaimer: 'Al dar click “Crear una cuenta" afirmas que estás de acuerdo con los <a class="textAnchor color-primary" href="/terms-of-use">términos de servicio de uso </a>y de <a class="textAnchor color-primary" href="/privacy-policy">Privacidad</a>.',
        errorMessage: 'Algo salió mal, inténtalo de nuevo'
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormSignUp/FormSignUpContent.js